import {
  CHECKEMAIL_REQUEST,
  CHECKEMAIL_SUCCESS,
  CHECKEMAIL_FAILURE,
  FINDAGENT_REQUEST,
  FINDAGENT_SUCCESS,
  FINDAGENT_FAILURE,
  CREATELEAD_REQUEST,
  CREATELEAD_SUCCESS,
  CREATELEAD_FAILURE,
  SENDMAGICEMAIL_REQUEST,
  SENDMAGICEMAIL_SUCCESS,
  SENDMAGICEMAIL_FAILURE,

} from "../actions/publicportal";

const initialState = {
  isFetching: false,
  error: undefined,
  agent: {},
  username: undefined,
  isDCLead: false,
  status: undefined,
  magicLinkSuccessMessage: 'We sent a Magic Link to your email. The link expires in 2 hours, so be sure to use it soon'
}

const publicportal = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CHECKEMAIL_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: undefined,
      };
    case CHECKEMAIL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: undefined,
        username: action.response?.user?.username,
        isDCLead: action.response?.isDCLead,
        status: "FOUND_CHECKEMAIL"
      };
    case CHECKEMAIL_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        status: "NOT_FOUND_CHECKEMAIL"
      };

    case FINDAGENT_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: undefined,
      };
    case FINDAGENT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: undefined,
        agent: action.response.agent,
        status: "FOUND_FINDAGENT"
      };
    case FINDAGENT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        status: "NOT_FOUND_FINDAGENT"
      };

    case CREATELEAD_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: undefined,
      };
    case CREATELEAD_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: undefined,
        status: "CREATELEAD_SUCCESS"
      };
    case CREATELEAD_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        status: "CREATELEAD_FAILURE"
      };

    case SENDMAGICEMAIL_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: undefined,
        status: "SENDMAGICEMAIL_REQUEST"
      };

    case SENDMAGICEMAIL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: undefined,
        status: "SENDMAGICEMAIL_SUCCESS",
        magicLinkSuccessMessage: action.response.message
      };

    case SENDMAGICEMAIL_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        status: "SENDMAGICEMAIL_FAILURE"
      };

    case "RESET_STATE":
      return initialState;

    default:
      return state;
  }
};

export default publicportal;